import { render, staticRenderFns } from "./FeedbacksWidget.vue?vue&type=template&id=163fbd2f"
import script from "./FeedbacksWidget.vue?vue&type=script&lang=js"
export * from "./FeedbacksWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports